module.exports = __webpack_public_path__ + "static/media/aluWall4.68f78dd4.jpeg";